import { s } from '../lib/sx'
import { A } from '../lib/router'
import { LegalHero } from '../components/PageHero'
import { legalMeta, paiaSections, privacySections, supplierSections, type LegalSection } from '../content/legal'

function Sections({ sections }: { sections: LegalSection[] }) {
  return (
    <>
      {sections.map((sec) => (
        <div key={sec.no} style={s('display:grid;grid-template-columns:52px minmax(0,1fr);gap:clamp(14px,2vw,32px);padding:34px 0;border-bottom:1px solid #DCE0E5;align-items:start;')}>
          <span style={s("font-family:'IBM Plex Mono',monospace;font-size:11px;letter-spacing:0.14em;color:#A8500F;padding-top:6px;")}>{sec.no}</span>
          <div>
            <h2 style={s('font-family:Archivo,sans-serif;font-weight:700;font-size:22px;letter-spacing:-0.015em;margin:0 0 12px;')}>{sec.h}</h2>
            <p style={s('font-size:16px;line-height:1.7;color:#38424E;margin:0;max-width:780px;text-wrap:pretty;')}>{sec.p}</p>
          </div>
        </div>
      ))}
    </>
  )
}

export function Paia() {
  return (
    <div>
      <LegalHero title="PAIA manual" meta={`Promotion of Access to Information Act 2 of 2000 · Section 51 · ${legalMeta.paiaVersion}`} />
      <section style={s('max-width:1100px;margin:0 auto;padding:clamp(48px,7vw,72px) clamp(18px,4vw,32px) 110px;')}>
        <Sections sections={paiaSections} />
        <div style={s('background:#DCE0E5;padding:clamp(18px,4vw,32px) 30px;margin-top:44px;')}>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#66707C;margin-bottom:12px;")}>Submit a request</div>
          <p style={s('font-size:15.5px;line-height:1.7;color:#1B2430;margin:0;')}>
            {legalMeta.paiaSubmitBefore}
            <A href="/contact" style={s('border-bottom:1px solid #A8500F;')}>
              {legalMeta.paiaSubmitLink}
            </A>
            {legalMeta.paiaSubmitAfter}
          </p>
        </div>
      </section>
    </div>
  )
}

export function Privacy() {
  return (
    <div>
      <LegalHero title="Privacy notice" meta={`Protection of Personal Information Act 4 of 2013 · ${legalMeta.privacyVersion}`} />
      <section style={s('max-width:1100px;margin:0 auto;padding:clamp(48px,7vw,72px) clamp(18px,4vw,32px) 110px;')}>
        <Sections sections={privacySections} />
        <div style={s('background:#1B2430;color:#B8C0CA;padding:34px clamp(18px,4vw,32px);margin-top:44px;')}>
          <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#E06A20;margin-bottom:12px;")}>Information Officer</div>
          <p style={s('font-size:15.5px;line-height:1.7;margin:0;')}>{legalMeta.informationOfficer}</p>
        </div>
      </section>
    </div>
  )
}

export function SupplierCode() {
  return (
    <div>
      <LegalHero title="Supplier code of conduct" meta={`Binding on every supplier, subcontractor and service provider · ${legalMeta.supplierVersion}`} />
      <section style={s('max-width:1100px;margin:0 auto;padding:clamp(48px,7vw,56px) clamp(18px,4vw,32px) clamp(48px,7vw,110px);')}>
        <p style={s('font-size:19px;line-height:1.6;color:#1B2430;margin:0 0 20px;max-width:820px;text-wrap:pretty;')}>{legalMeta.supplierIntro}</p>
        <Sections sections={supplierSections} />
        <div style={s('display:grid;grid-template-columns:repeat(auto-fit,minmax(min(100%,260px),1fr));gap:24px;margin-top:44px;')}>
          <div style={s('background:#DCE0E5;padding:clamp(18px,4vw,32px) 30px;')}>
            <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#66707C;margin-bottom:12px;")}>Register as a supplier</div>
            <p style={s('font-size:15.5px;line-height:1.7;color:#1B2430;margin:0 0 18px;')}>{legalMeta.supplierRegister}</p>
            <A href="/contact" style={s("font-family:'IBM Plex Mono',monospace;font-size:12px;letter-spacing:0.14em;text-transform:uppercase;border-bottom:2px solid #A8500F;padding-bottom:4px;")}>
              Contact us →
            </A>
          </div>
          <div style={s('background:#1B2430;color:#B8C0CA;padding:clamp(18px,4vw,32px) 30px;')}>
            <div style={s("font-family:'IBM Plex Mono',monospace;font-size:10.5px;letter-spacing:0.18em;text-transform:uppercase;color:#E06A20;margin-bottom:12px;")}>Report a breach</div>
            <p style={s('font-size:15.5px;line-height:1.7;margin:0;')}>{legalMeta.supplierReport}</p>
          </div>
        </div>
      </section>
    </div>
  )
}
